import gql from 'graphql-tag';
import { kmsClient } from 'api';
import { useLazyQuery } from '@apollo/react-hooks';
import { GeneratePreview, GeneratePreviewVariables } from './__generated__/GeneratePreview';

export const GENERATE_PREVIEW = gql`
  query GeneratePreview($campaignId: ID!, $postIds: [String!]!) {
    generatePreviewForPost(campaignId: $campaignId, postIds: $postIds) {
      preview
      postId
    }
  }
`;

export const useGeneratePreview = () => {
  return useLazyQuery<GeneratePreview, GeneratePreviewVariables>(GENERATE_PREVIEW, {
    client: kmsClient,
    fetchPolicy: 'cache-first'
  });
};
